import BaseComponent from "../../baseComponent.js";
import styles from "../../common/card.scss";

const barChartImg = require('file!../../../img/demo/bar-chart.png');
const heatmapChartImg = require('file!../../../img/demo/heatmap.jpg');
const areaChartImg = require('file!../../../img/demo/area-chart.jpg');
const lineChartImg = require('file!../../../img/demo/line-chart.png');
const donutChartImg = require('file!../../../img/demo/Donut.png');

export default class DatasetCard extends BaseComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    window.flipperTimeout += 60;
    this.$flipper = $(this.refs.flipper);
    this.$flipper.addClass("flip-ready");

    setTimeout(() => {
      this.$flipper.addClass("flipped").removeClass("flip-ready");
    }, window.flipperTimeout);
  }

  onTileClick() {
    this.props.onDetailClick(this.props.dataset);
  }

  flipCard(event) {
    if (event.target.tagName === 'INPUT') return;
    if ($(event.target).hasClass("material-icons")) return;
    this.$flipper.toggleClass("flipped");
  }

  copyDatasetId() {
    this.refs.datasetId.select();
    try {
      document.execCommand('copy');
      this.refs.datasetId.blur();
    }
    catch (err) {
    }
  }

  render() {
    let img = areaChartImg, imageStyle = {};
    switch (this.props.dataset.dataProfileId) {
      case "D9838F30-9CF0-11E5-A1EB-E6D22AC3494E".toLowerCase():
      case "3EF42956-FB76-4C26-BDB4-6E237A2B673B".toLowerCase():
        // Tickcount: stack bar
        img = barChartImg;
        break;
      case "5804723C-8687-4128-8970-70B13AF673C6".toLowerCase():
        img = heatmapChartImg;
        break;
      case "E0C8E869-750C-4B4E-8A46-8D2317622C0E".toLowerCase():
        img = lineChartImg;
        break;
      case "F3E94CD1-A294-4C98-B870-5F0216C1FAE4".toLowerCase():
        // className = "tile-donut";
        img = donutChartImg;
        imageStyle = {width: "100px"};
        break;
      case "FF287F4A-63DB-420E-ACB0-A3DAA822EDA2".toLowerCase():
      case "BA60FA70-9CF0-11E5-8351-E6D22AC3494E".toLowerCase():
      default:
    }

    let userName = this.props.dataset.userFirstName + " " + this.props.dataset.userLastName;
    let createdBy = this.props.dataset.organizationId != null ? this.props.dataset.organizationName : userName;

    return (
      <div className="col flip noslsect" onClick={(e) => this.flipCard(e)}>
        <div className="flipper" ref="flipper">
          <div className="face front">
            <div className={styles.description}>{this.props.dataset.description}</div>
            <div className={styles.label}>DATASET ID</div>
            <div className={["waves-effect waves-light btn", styles.datasetId].join(" ")} onClick={this.copyDatasetId}>
              <input type="text" ref="datasetId" value={this.props.dataset.datasetId} readOnly/>
            </div>
            <div className={styles.actions}>
              <div className={styles.detailBtn} onClick={() => this.onTileClick()}>
                <i className="material-icons">menu</i>
              </div>
            </div>
          </div>
          <div className="face back">
            <div className={styles.name}>
              <span>{this.props.dataset.name}</span>
            </div>
            <div className={styles.image}>
              <img src={img} style={imageStyle}/>
            </div>
            <div className={styles.label}>FROM</div>
            <div className={styles.createdBy}>{createdBy}</div>
            <div className={styles.actions}>
              <div className={styles.detailBtn} onClick={() => this.onTileClick()}>
                <i className="material-icons">menu</i>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/data-bank/datasets/datasetCard.jsx